// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"CardWrapper_cardWrapper__2y9tk"};